<template>
  <div class="teaching-evaluate-statistics-detail">
    <div class="header">
      <NavBar title="查看评教详情"
              border
              @back="hidePopover">
        <template #extra>
          <div class="extra">
            <el-link class="el-button el-button--default el-button--mini"
                     :underline="false"
                     :href="$contextPath(`/workspace/manager/teaching/evaluate/query/exportScheduleEvaluation?semester=${semester}&scheduleId=${rowData.id}`)"
                     target="_blank">
              <span>导出学生评教详情</span>
            </el-link>
          </div>
        </template>
      </NavBar>
    </div>
    <div class="main">
      <div class="main-cont">
        <TeachingEvaluateStatisticsDetailMain :semester="semester"
                                              :schedule-id="rowData.id"
                                              v-bind="$attrs"></TeachingEvaluateStatisticsDetailMain>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '../../../../../../../widgets/NavBar'
import TeachingEvaluateStatisticsDetailMain from './main'
export default {
  name: 'TeachingEvaluateStatisticsDetail',
  components: {
    NavBar,
    TeachingEvaluateStatisticsDetailMain
  },
  props: {
    semester: {
      type: String,
      required: true
    },
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    hidePopover () {
      this.$emit('hidePopover')
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-statistics-detail {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      .extra {
        .el-button {
          padding: 6px 15px;
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
